import React from 'react';
import {ReactComponent as NewIcon} from '../../../../../../../../assets/calendar/new.svg';
import {ReactComponent as FinishedIcon} from '../../../../../../../../assets/calendar/finished.svg';
import {ReactComponent as ProblemsIcon} from '../../../../../../../../assets/calendar/problems.svg';
import {ReactComponent as InProgressIcon} from '../../../../../../../../assets/calendar/inProgress.svg';


interface EventComponentProps {
    status: string;
    hasProblem: boolean;
    start: Date;
}

const EventComponent: React.FC<EventComponentProps> = ({status, hasProblem, start}) => {
    const startTime = start.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});

    let statusClassName = '';
    let statusIcon = null;

    if (status === 'new') {
        statusClassName = hasProblem ? 'problems-new' : 'new';
        statusIcon = hasProblem ? <ProblemsIcon/> : <NewIcon/>;
    } else if (status === 'finished') {
        statusClassName = hasProblem ? 'problems-finished' : 'finish';
        statusIcon = hasProblem ? <ProblemsIcon/> : <FinishedIcon/>;
    } else if (status === 'inProgress') {
        statusClassName = hasProblem ? 'problems-in-progress' : 'new';
        statusIcon = <InProgressIcon/>;
    }

    return (
        <div className={`calendar-status-block ${statusClassName}`}>
            <span>{statusIcon}</span>
            <span>{startTime}</span>
        </div>
    );
};

export default EventComponent;
